import React from 'react';

import {
    token,
} from '@zillow/constellation';

import {
    StyledBar,
} from './StyledComponents';

const ProgressBar = ({
    isActive,
}) => (
    <div>
        <StyledBar borderColor={(isActive ? token('colors.brand') : token('colors.gray300'))} />
    </div>
);

export { ProgressBar };
export default ProgressBar;
